// import History from './History';

export default {
  priority: 1,
  path: 'history',
  permissions: ['SecurityRequestsMenu'],
  // component: History,
  component: load(() => import(/* webpackChunkName: "Guardian-History" */ './History')),
  name: app.translate('routes.home.requests.Requests'),
  icon: 'email-variant',
  drawer: true,
};


